module.exports = __webpack_public_path__ + "assets/img/29_684_big.513fd586.jpg";